// Importando as dependências
import * as i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

// NO PRÓXIMO PASSO EU MOSTRO AS TRADUÇÕES
// Buscando as nossas traduções da pasta locales (nome e local da pasta é você quem decide)
import translations from './locale';
const detectionOptions = {
  order: ['navigator'],  // Define as fontes de detecção de idioma em ordem de prioridade
  lookupQuerystring: 'lang',  // Caso queira permitir a definição de idioma via query string
  caches: [],  // Se desejar, especifique métodos de cache, como 'localStorage'
  checkWhitelist: true,  // Verifica se o idioma detectado está na lista de idiomas permitidos
};
// Configuração i18n
const i18nConfig: i18n.InitOptions = {
  resources: translations,  // resources são as nossas traduções
  fallbackLng: 'en',     // fallbackLng é o idioma padrão caso o browser não consiga detectar sozinho
  defaultNS: 'translations', // defaultNS é o namespace padrão, podemos usar 'translations'

  interpolation: {
    escapeValue: false,  // não escape strings
    prefix: '{{',
    suffix: '}}'
  }
};

// Não vou entrar no assunto namespaces, nem em configurações mais complexas
// O objetivo é simplicidade

i18n
  .use(LanguageDetector) // Usa o detector de idioma do seu browser
  .use(initReactI18next) // Usa o pacote do i18n específico para React
  .init({
    ...i18nConfig, // Usa nossas configurações
    detection: detectionOptions,  // Usa as opções de detecção de idioma
  }); // Usa nossas configurações

export default i18n;